<script context="module">
  import { External as Ext, M as Messages } from '../external';
  import MaterialIconPicker from './MaterialIconPicker.svelte';

  export let loadIcon = async (icon) => {
    let result = await fetch(`https://static.web-repository.com/images/material-icons/${icon}/materialsymbolsoutlined/${icon}_24px.svg`);
    if (result.ok) {
      return await result.text();
    }
    return '';
  }

  export let pickIcon = (options) => {
    options = {
      ...{
        withDarkBackground: true,
        addCloseButton: true,
        isModal: false,
        width: 583,
        title: Messages.PICK_ICON
      },
      ...(options || {})
    };

    return new Promise((resolve) => {
      let selectedIcon = '';
      Ext.Tools.showWindow({
        title: options.title,
        icon: Ext.Popup.ICON_EDIT,
        width: options.width,
        addCloseButton: options.addCloseButton,
        customClass: 'material-icon-picker-dialog',
        isModal: options.isModal,
        withDarkBackground: options.withDarkBackground,
        forceAtRight: false,//Ext.showBuilderPopupsOnFullHeight,
        action: {
          onShow: (popup, context) => {
            popup.bindComponent(
              new MaterialIconPicker({
                target: popup.getContentArea(),
                props: {
                  onSelect: async (icon) => {
                    selectedIcon = await loadIcon(icon);
                    popup.close();
                  }
                }
              }));
          },
          onHide: () => {
            resolve(selectedIcon);
          }
        }
      });
    });
  };
</script>

<script>
  import { External, M } from '../external';
  import { onMount } from 'svelte';
  import Loader from './Loader.svelte';

  export let onSelect;
  let icons = [];
  let filteredIcons = icons;
  let search = '';
  let loading = true;

  let select = (icon) => {
    onSelect(icon);
  };

  let onSearch = () => {
    let key = search.toLowerCase();
    filteredIcons = icons.filter(icon => {
      return icon.name.toLowerCase().startsWith(key) || icon.tags.filter(tag => tag.toLowerCase().startsWith(key)).length > 0;
    });
  };

  let init = (loadStartTime) => {
    icons = window.MATERIAL_ICONS;
    filteredIcons = icons;
    let loadingTime = new Date().getTime() - loadStartTime;
    // ensure 1s loading time to give time fonts to load
    setTimeout(() => {
      loading = false;
    }, Math.max(10, 1000 - loadingTime));
  };

  onMount(() => {
    let start = new Date().getTime();
    if (window.MATERIAL_ICONS) {
      init(start);
    } else {
      External.Tools.loadScripts(External.staticResource('/scripts/common/material-icons.js'), () => {
        init(start);
      });
    }
  });
</script>

<svelte:head>
  <link rel="stylesheet"
        href="https://fonts.googleapis.com/css2?display=block&family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
</svelte:head>
<style>
  .material-symbols-outlined {
    float: left;
    padding: 14px;
    margin: 4px 4px 4px 4px;
    text-align: center;
    cursor: pointer;
    border-radius: 8px;
    font-size: 30px;
    background: #ffffff;
    transition: background 0.2s;

    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
  }

  .material-symbols-outlined:hover {
    border-radius: 3px;
    background: #f0f0f0;
  }

  .icon-box {
    float: left;
    width: 100%;
    box-sizing: border-box;
    padding: 15px 23px;
  }
</style>
{#if loading}
  <Loader compact="big" />
{:else}
  <div class="col20 f-left">
    <input type="search" class="form-control iconpicker-search" placeholder={M.SEARCH} bind:value={search} on:keyup={onSearch} on:change={onSearch} />
  </div>
  {#if filteredIcons.length === 0}
    <div class="flex flex-col align-center col20 f-left icon-box">
      <span style="font-size: 20px; font-family: Roboto">(;-;)</span>
      <span style="font-size: 18px;">No icons found for <b>{search}</b></span>
    </div>
  {:else}
    <div class="icon-box">
      {#each filteredIcons as icon}
      <span class="material-symbols-outlined" on:click={() => select(icon.name)}>
        {icon.name}
      </span>
      {/each}
    </div>
  {/if}
{/if}
